import { render } from "./LibContentBlocksItemBanner.vue?vue&type=template&id=e40170d8&scoped=true&ts=true"
import script from "./LibContentBlocksItemBanner.vue?vue&type=script&lang=ts"
export * from "./LibContentBlocksItemBanner.vue?vue&type=script&lang=ts"

import "./LibContentBlocksItemBanner.vue?vue&type=style&index=0&id=e40170d8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e40170d8"]])

export default __exports__